import React, { Suspense } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import configStore from './redux/store/storeConfig';
import LoginPage from '@modules/system/pages/LoginPage';
import SessionExpiredPage from '@modules/system/pages//SessionExpiredPage';
import AdminPage from './components/Layout/AdminPage';
import './i18n';
import './App.scss';

const store = configStore();

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 5 * 60 * 1000, // 5 phút
        },
    },
});

const router = createBrowserRouter([
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/session-expired',
        element: <SessionExpiredPage />,
    },
    {
        path: '/*',
        element: <AdminPage />,
    },
]);

const App = () => (
    <Suspense fallback={null}>
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </Provider>
    </Suspense>
);

export default App;
